import React from 'react';
import AccountInformation from './AccountInformation';

/**
 * Settings Component - Redirects to AccountInformation
 * Maintains backward compatibility for existing routes
 */
function Settings() {
  // Redirect to the new AccountInformation component
  return <AccountInformation />;
}

export default Settings;